<template>
  <div data-testid="shop-cart-summary" class="flex w-full flex-col items-end gap-1">
    <div class="flex w-full items-center justify-between py-1">
      <div class="flex items-center gap-1">
        <span class="txt-body-l-bold text-main">{{ t('FestivalShop.cart.totalExclVat') }}</span>
      </div>
      <span data-testid="shop-cart-summary-total" class="text-right txt-body-l-bold text-main">{{
        formatPrice(total, locale as LocaleEnum)
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import type { LocaleEnum } from '@/gql/myomr'

import { formatPrice } from '../helpers'

const { t, locale } = useI18n()

export interface Props {
  total: number
}

defineProps<Props>()
</script>
